// Generated by psc version 0.10.2
"use strict";
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-prelude/src/Data/NaturalTransformation.purs
// module id = 104
// module chunks = 0